import { QueryClient } from "@tanstack/react-query";
import { isApiError } from "./api/client";

/**
 * Retrying a 4xx is always wrong and occasionally harmful: the server has
 * already answered definitively, and three more identical requests turn one
 * rejected call into a rate-limit. Retry transport failures and 5xx only.
 */
function retry(failureCount: number, error: unknown): boolean {
  if (isApiError(error) && error.status >= 400 && error.status < 500) {
    return false;
  }
  return failureCount < 2;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry,
      staleTime: 30_000,
      // An installed app is backgrounded and foregrounded constantly; refetching
      // every query on every focus is a traffic multiplier, not freshness.
      refetchOnWindowFocus: false,
    },
    mutations: {
      // A mutation retry needs server-side de-duplication to be safe, and
      // there is none. Retrying a lost DELETE could act twice.
      retry: false,
    },
  },
});
